import React, { Component } from 'react';
import {
    Label,
    Row,
    Col,
    Button
} from 'reactstrap';
import '../../Notes/Notes.css';

class ListOpportunitiesNotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
        this.updatedTS = parseInt(String(props.row.timestamp).substr(5, 2)) + '/' + parseInt(String(props.row.timestamp).substr(8, 2)) + '/' + String(props.row.timestamp).substr(2, 2);
    }

    toggleExpand = (e) => {
        e.stopPropagation(); // prevent firing the row click
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const { row, addCategoryCommentsArray, handleEditSwap } = this.props;
        const { expanded } = this.state;

        const fullNoteText = String(row.notes || '');
        const isLong = fullNoteText.length > 150;
        const displayedText = (!isLong || expanded) ? fullNoteText : fullNoteText.slice(0, 150) + '...';

        return (
            <Row key={row.id} className="notesFormTypeRow pointer" onClick={() => handleEditSwap(row.id)}>
                <Col sm={8} className="notesFormTypeComments text-left">
                    <>
                        <Row className="notesFormCommentRow">
                            <Col className="pb-1">
                                <Label>{addCategoryCommentsArray.find(item => item.type === 'Activity')?.list?.find(item => item.ID === row.typeID)?.description || ''}</Label>
                            </Col>
                        </Row>
                        <Row className="notesFormCommentRow">
                            <Col className="pt-1">
                                {/* Display note text */}
                                {displayedText.split("\n").map((item, idx) => (
                                    <div key={item + '_' + idx}>
                                        {item}
                                        <br />
                                    </div>
                                ))}
                                {/* Show "Show more"/"Show less" button if needed */}
                                {isLong && (
                                    <div className="mt-2">
                                        <Button color="secondary" size="sm" onClick={this.toggleExpand}>
                                            {expanded ? 'Show less' : 'Show more'}
                                        </Button>
                                    </div>
                                )}
                                {(row.custodians || []).length > 0 && (
                                    <div className="mt-2">
                                        <strong>Custodians:</strong> {row.custodians.map(custodian => custodian.name).join(', ')}
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </>
                </Col>
                <Col sm={4} className="notesFormTypeControls text-right mt-2">
                    <div className="noteCreatedTimestamp">
                        {this.updatedTS}
                    </div>
                    <div className="noteCreatedTimestamp" title={String(row.timestamp).substr(11, 2) + ':' + String(row.timestamp).substr(14, 2) + ' by ' + row.user.firstName + ' ' + row.user.lastName}>
                        {row.firstName + ' ' + row.lastName}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ListOpportunitiesNotes;
